import TextField from '@material-ui/core/TextField';
import React from 'react';

const CustomTextField = ({label, input, meta: {touched, invalid, error}, ...custom}) => {
    return (
        <TextField
            label={label}
            error={touched && invalid}
            helperText={(touched && error) || (<span>&nbsp;</span>)}
            fullWidth
            InputLabelProps={{shrink: !!input.value}}
            {...input}
            {...custom}
        />
    );
};

CustomTextField.defaultProps = {
    margin: 'normal',
    variant: 'standard',
};

export default (CustomTextField);
